
export function getNavItems(userRoles: string[]) {
  // Normalize roles
  const roles = userRoles.map(r => r.toLowerCase());

  if (roles.includes('admin')) {
    return [
      {
        name: 'Tableau de bord',
        url: '/admin/dashboard',
        iconComponent: { name: 'cis-home' }
      },
      {
        name: 'Contrats',
        url: '/admin/contracts',
        iconComponent: { name: 'cis-document' }
      },
      {
        name: 'Prix call out',
        url: '/admin/cities',
        iconComponent: { name: 'cis-location-pin' }
      },
      {
        name: 'Clients',
        url: '/admin/clients',
        iconComponent: { name: 'cis-group' }
      },
      {
        name: 'Déneigeurs',
        url: '/admin/technicians',
        iconComponent: { name: 'cis-people' }
      },
      {
        name: 'Connecteurs',
        url: '/admin/connectors',
        iconComponent: { name: 'cis-input-component' }
      },
      {
        name: 'Tutoriels',
        url: '/admin/tutorials',
        iconComponent: { name: 'cilBook' }
      }
    ];
  } else if (roles.includes('billing') || roles.includes('user')) {
    return [
      {
        name: 'Profil',
        url: '/user/clients',
        iconComponent: { name: 'cil-user' },
        linkProps: { fragment: 'top' }
      },
      {
        name: 'Tutoriels',
        url: '/tutorials',
        iconComponent: { name: 'cilBook' }
      }
    ];
  } else {
    return [];
  }
}
